import {
  LucideIcon,
  Megaphone,
  Rocket,
  ShieldUser,
  Star,
  Trophy,
} from "lucide-react";

// Sentinel value for default badge color
// This will be rendered as theme.palette.text.secondary at runtime
export const DEFAULT_BADGE_COLOR = "DEFAULT";

export interface BadgeConfig {
  label: string;
  icon: LucideIcon;
  color: string; // Use DEFAULT_BADGE_COLOR for theme.palette.text.secondary, or provide a hex color
  description: string;
  isSingular: boolean;
}

export const BADGE_CONFIG: Record<string, BadgeConfig> = {
  admin: {
    label: "Admin",
    icon: ShieldUser,
    color: DEFAULT_BADGE_COLOR,
    description: "Faye administrator",
    isSingular: true,
  },
  entrepreneur: {
    label: "Entrepreneur",
    icon: Rocket,
    color: "#EF7B77",
    description: "One for every directly sourced family",
    isSingular: false,
  },
  all_star: {
    label: "All-Star",
    icon: Star,
    color: "#EAB308",
    description: "One for every 5-star review",
    isSingular: false,
  },
  veteran: {
    label: "Veteran",
    icon: Trophy,
    color: "#F59E0B",
    description: "100+ months of Faye service",
    isSingular: true,
  },
  ambassador: {
    label: "Ambassador",
    icon: Megaphone,
    color: "#3B82F6",
    description: "One for every affiliate link signup",
    isSingular: false,
  },
};

export const ACTIVE_BADGES = [
  "admin",
  "entrepreneur",
  "all_star",
  "veteran",
  "ambassador",
];

// Standard sort order for badges
export const BADGE_SORT_ORDER = [
  "admin",
  "entrepreneur",
  "ambassador",
  "all_star",
  "veteran",
];
